import { post, get,postJson,deleteApi } from '../axios'

export const listDongDong = p => get(`/smsDongDongRecord/page`, p)